import React from 'react';
import PropTypes from 'prop-types';
import { EventsIcon, ClockIcon } from '../../model/icons';
import { formatEventTime } from './eventDates';

// Карточка мероприятия (.ev-card): постер + название + время.
export default function EventCard({ event, imageUrl, onClick }) {
    return (
        <button type="button" className="ev-card" onClick={onClick}>
            <div className="ev-poster">
                {imageUrl ? <img src={imageUrl} alt={event.title || ''} /> : <EventsIcon />}
            </div>
            <div className="ev-body">
                <div className="et">{event.title || 'Мероприятие'}</div>
                {event.startTime && (
                    <div className="ev-time"><ClockIcon />{formatEventTime(event.startTime)}</div>
                )}
            </div>
        </button>
    );
}

EventCard.propTypes = {
    event: PropTypes.shape({
        title: PropTypes.string,
        startTime: PropTypes.string
    }).isRequired,
    imageUrl: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

EventCard.defaultProps = { imageUrl: null };
